import Vue from 'vue'
/**
 *区域分布信息
 */
export const devAreaInfo = (params) => {
  return Vue.fetch.post('/apiv1/dashboard/devAreaInfo', params)
}

export const devTypeTotal = (params) => {
  return Vue.fetch.post('/apiv1/dashboard/devTypeTotal', params)
}

export const devNewAddedTotal = (params) => {
  return Vue.fetch.post('/apiv1/dashboard/devNewAddedTotal', params)
}

export const devLocationTotal = (params) => {
  return Vue.fetch.post('/apiv1/dashboard/devLocationTotal', params)
}



// WEBPACK FOOTER //
// ./src/services/dashboardApi.js